<template>
  <div class="config-form-content weeduc-admin-config adminWeeducConfig weeduc-admin-integrations" v-if="hasReady">
    <div class="weeduc-admin-integrations__intro">
      <h3 class="weeduc-admin-integrations__title">Integrações</h3>
      <p class="weeduc-admin-integrations__lead">Pixels de anúncio e credenciais do RD Station.</p>
    </div>
    <div class="row g-3 g-lg-4 weeduc-admin-config-layout mx-0">
      <div class="col-12 col-lg-6 weeduc-admin-config-col">
        <div class="weeduc-admin-config-section">
          <h3 class="weeduc-admin-config-section-title">Pixels</h3>
          <p class="weeduc-admin-config-section-lead">Códigos usados para medir visitas e conversões.</p>
          <div class="form-group">
            <label class="form-label" for="weflixIntegrationFacebook">Facebook Pixel</label>
            <input id="weflixIntegrationFacebook" v-model="facebook" type="text" class="form-input" placeholder="GTM-28CJ0" autocomplete="off" />
            <small class="form-small-description">Rastreia o comportamento dos visitantes pelo Facebook.</small>
          </div>
          <div class="form-group">
            <label class="form-label" for="weflixIntegrationGads">Google Ads</label>
            <input id="weflixIntegrationGads" v-model="gads" type="text" class="form-input" placeholder="GTM-28CJ0" autocomplete="off" />
            <small class="form-small-description">Rastreia conversões das campanhas do Google Ads.</small>
          </div>
          <div class="form-group">
            <label class="form-label" for="weflixIntegrationGa">Google Analytics</label>
            <input id="weflixIntegrationGa" v-model="ganalytic" type="text" class="form-input" placeholder="G-XXXXXXXX" autocomplete="off" />
            <small class="form-small-description">Mede audiência e páginas mais acessadas.</small>
          </div>
          <div class="form-group">
            <label class="form-label" for="weflixIntegrationGtm">Tag Manager</label>
            <input id="weflixIntegrationGtm" v-model="tagManager" type="text" class="form-input" placeholder="GTM-XXXX" autocomplete="off" />
            <small class="form-small-description">Concentra as tags de marketing em um único código.</small>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 weeduc-admin-config-col">
        <div class="weeduc-admin-config-section">
          <h3 class="weeduc-admin-config-section-title">RD Station</h3>
          <p class="weeduc-admin-config-section-lead">Credenciais da integração com o RD Station.</p>
          <div class="form-group">
            <label class="form-label" for="weflixIntegrationRdRefresh">Refresh token</label>
            <input id="weflixIntegrationRdRefresh" v-model="rdrefreshToken" type="text" class="form-input" autocomplete="off" />
            <small class="form-small-description">Token usado para renovar o acesso à API.</small>
          </div>
          <div class="form-group">
            <label class="form-label" for="weflixIntegrationRdCode">Code</label>
            <input id="weflixIntegrationRdCode" v-model="rdcode" type="text" class="form-input" autocomplete="off" />
            <small class="form-small-description">Código de autorização da conta.</small>
          </div>
          <div class="form-group">
            <label class="form-label" for="weflixIntegrationRdSecret">Secret client</label>
            <input id="weflixIntegrationRdSecret" v-model="rdSecret" type="text" class="form-input" autocomplete="off" />
            <small class="form-small-description">Segredo do aplicativo no RD Station.</small>
          </div>
          <div class="form-group">
            <label class="form-label" for="weflixIntegrationRdClient">Client ID</label>
            <input id="weflixIntegrationRdClient" v-model="rdClient" type="text" class="form-input" autocomplete="off" />
            <small class="form-small-description">Identificador público do aplicativo.</small>
          </div>
        </div>
      </div>
    </div>
    <div class="buttons-container weeduc-admin-site-form-actions">
      <div class="button d-flex flex-wrap gap-2 justify-content-end">
        <button type="button" class="btn btn-block btn-content" @click="updateIntegrations">Salvar</button>
      </div>
    </div>
  </div>
  <Loader :hasReady="hasReady" />
</template>

<script>
import websiteApi from '@/utils/Weflix/website';
import { mapState } from 'vuex';
import Loader from '@/components/Weflix/Loader.vue';
import { toast } from 'vue3-toastify';

function fillBlank(target, key, value) {
  if (target[key] == null || String(target[key]).trim() === '') {
    target[key] = value;
  }
}

export default {
  data(){
      return{
          facebook: '',
          gads: '',
          ganalytic: '',
          tagManager: '',
          rdrefreshToken: '',
          rdcode: '',
          rdSecret: '',
          rdClient: '',
          hasReady: false,
          descriptionAbout:'',
          windowWidth: window.innerWidth,
      }
  },
  computed: {
    ...mapState(['token', 'layoutWebsite']),
    responsiveClassOne() {
      if (this.windowWidth <= 600) {
        return "col-form-outer col-12 col-md-6 col-lg-6 col-1";
      } else {
        return "col-form-outer col-6 col-md-6 col-lg-6 col-1";
      }
    },
    responsiveClassTwo() {
      if (this.windowWidth <= 600) {
        return "col-form-outer col-12 col-md-6 col-lg-6 col-2";
      } else {
        return "col-form-outer col-6 col-md-6 col-lg-6 col-2";
      }
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  components: {
      Loader,
  },
  methods:{
    fillPreviewData() {
      fillBlank(this, 'facebook', '123456789012345');
      fillBlank(this, 'gads', 'AW-123456789');
      fillBlank(this, 'ganalytic', 'G-PREVIEW01');
      fillBlank(this, 'tagManager', 'GTM-PREV01');
      fillBlank(this, 'rdrefreshToken', 'rd-refresh-preview');
      fillBlank(this, 'rdcode', 'rd-code-preview');
      fillBlank(this, 'rdSecret', 'rd-secret-preview');
      fillBlank(this, 'rdClient', 'rd-client-preview');
    },
    async getIntegrations() {
      // Pegando os campos do layoutWebsite (do Vuex) e adicionando os campos novos desta view
      const layout = this.layoutWebsite;
      if (layout) {
        // this.id = layout.id;
        this.name = layout.nome ?? '';
        this.description = layout.description;
        this.logo = layout.logo;
        this.favicon = layout.favicon;
        this.logoPreview = layout.logoFinal;
        this.faviconPreview = layout.faviconFinal;
        this.url = layout.url;
        this.status = layout.status;
        this.hasReady = true;
        this.activeTheme = layout.typeLayout;
        this.color = layout.color;
           // Campos de integrações (novos ou sobrescrevendo)
      this.facebook = layout.facebookPixelCode;
      this.gads = layout.googleAdsCode;
      this.ganalytic = layout.googleAnalyticsCode;
      this.tagManager = layout.tagManagerCode;
      this.rdrefreshToken = layout.rdrefreshToken;
      this.rdcode = layout.rdcode;
      this.rdSecret = layout.rdsecretClient;
      this.rdClient = layout.rdclienteId;
      this.descriptionAbout = layout.about;
      }

      
    },
    async updateIntegrations() {
      this.hasReady = false;
      // Pegando os campos do layoutWebsite (do Vuex) e sobrescrevendo com os campos atuais do formulário
      const layout = this.layoutWebsite;
      const payload = {
        description: this.description ?? layout.description,
        logo: this.logo ?? layout.logo,
        favicon: this.favicon ?? layout.favicon,
        nome: this.name ?? layout.nome,
        status: this.status ?? layout.status,
        url: this.url ?? layout.url,
        typeLayout: this.activeTheme ?? layout.typeLayout,
        color: this.color ?? layout.color,

        facebookPixelCode: this.facebook,
        googleAdsCode: this.gads,
        googleAnalyticsCode: this.ganalytic,
        tagManagerCode: this.tagManager,
        rdrefreshToken: this.rdrefreshToken,
        rdcode: this.rdcode,
        rdsecretClient: this.rdSecret,
        rdclienteId: this.rdClient,
        about: this.descriptionAbout
      }
      try {
        const responseId = await websiteApi.getWebsite(this.token);
        let idWebsite = responseId.id;
        const response = await websiteApi.editWebsite(this.token, idWebsite, payload);
        this.getIntegrations();
        this.hasReady = true;
        this.notify('Integrações atualizadas com sucesso!', 'success');
      } catch (error) {
        this.notify('Erro ao atualizar integrações.', 'error');
        console.error('Erro ao atualizar dados do website:', error);
      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    notify(message, type = "info") {
            toast(message, {
                autoClose: 3000,
                position: 'top-right',
                theme: "light", 
                limit: 1,
                type: type,
                dangerouslyHTMLString: true
            });
      },
  },
  created() {
    this.getIntegrations()
  }
}
</script>
<style scoped>
@import url('@/css/weeduc/admin/dashboard-weflix-shell.css');
@import '@/css/weeduc/admin/config.css';
@import '@/css/weeduc/admin/integrations.css';
</style>
